import { Lodash } from '@/utils';

const common = {
    queryJoin(url, key, value) {
        if (url.indexOf('?') > -1) {
            url += '&';
        } else {
            url += '?';
        }
        url += `${key}=${(value)}`;
        return url;
    },
    paramsToQueryString(url, params) {
        // 目前只转换以下值类型：Array, Number, String
        if (!Lodash.cloneDeep(params)) {
            throw new Error('queryParams must Object!!');
        }
        if (Lodash.isObject(params) && !Lodash.isEmpty(params)) {
            for (const key in params) {
                if (Lodash.isArray(params[key])) {
                    params[key].forEach((val) => {
                        url = this.queryJoin(url, key, encodeURIComponent(val));
                    });
                } else {
                    url = this.queryJoin(url, key, encodeURIComponent(params[key]));
                }
            }
        }
        return url;
    },
    /**
     * 动态匹配参数替换(仅匹配形如':id/'或者'id/ ')
     * 如果后台api以/结尾 匹配':id/'
     * 如果后台api不以/结尾 匹配':id '，注意空格~
     */
    replaceQuery(path, options) {
        let url = path.replace(/:(.*?)(\/|\?| )/g, (a, b, c) => {
            const value = options.params[b];
            delete options.params[b];
            return `${value}${c}`;
        }).trim();
        if (options.method === 'GET') {
            // 如果是GET请求，将对应参数转化为query params
            if (options.params) {
                url = this.paramsToQueryString(url, options.params);
            }
        }
        return url;
    },
    /**
     * 类型判断
     * @param target
     * @param type
     * @returns {boolean}
     */
    isThisType(target, type) {
        return Object.prototype.toString.call(target) === `[object ${type}]`;
    }

}
export default common;



// WEBPACK FOOTER //
// ./src/utils/common.js